import { SET_LOAD_BOUNTIES_FILTER, CLEAR_LOAD_BOUNTIES_FILTER } from './actionTypes'
import moment from 'moment-timezone'

const getInitialState = () => {
    const today = moment.tz('America/Chicago')
    const day = today.date()

    return {
        pickup_date_begin: today.clone()
            .startOf('month')
            .subtract(day < 7 ? 1 : 0, 'month')
            .format('MM/DD/YYYY'),

        pickup_date_end: today.clone()
            .add(day > 22 ? 1 : 0, 'month')
            .endOf('month')
            .format('MM/DD/YYYY'),

        statuses: ['ACTIVE'],
        user: null
    }
}

export default (state = getInitialState(), action) => {
    switch (action.type) {
    case SET_LOAD_BOUNTIES_FILTER:

        return action.filter

    case CLEAR_LOAD_BOUNTIES_FILTER:
        return getInitialState()

    default:
        return state
    }
}